module.exports = "<br>\n<div id=\"toolbar\" style=\"margin:0 auto;\">\n  <header [@fallIn]=\"state\">\n    <button (click)=\"logout()\" class=\"basic-btn\">Logout</button>\n  </header>\n  <div id=\"page\" [@moveInLeft]=\"state\">\n    <h2>Hey {{ name }}!</h2>\n\n    <img src=\"assets/images/filler.png\" />\n  </div>\n  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loged-in/loged-in.component.html
// module id = ./src/app/loged-in/loged-in.component.html
// module chunks = main